import { TokenResponse, useGoogleLogin } from '@react-oauth/google';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import React from 'react';
import { IconGoogle } from '../Icon';
import { useExternalLoginMutation } from '../../Apis/Common/externalAuthApi';
import { apiResponse, userModel } from '../../Interfaces';
import { jwtDecode } from 'jwt-decode';
import { setLoggedInUser } from '../../Storage/Redux/slice/userAuthSlice';
import { useDispatch } from 'react-redux';
import { HttpStatusCode } from 'axios';
import { setUser } from '../../Storage/Redux/slice/resetUserSlice';
import { rtkErrorRead, toastNotify } from '../../Helper';
import { storeAuthToken } from '../../Helper/authToken';

function GoogleLoginButton({
  id,
  setLoading,
}: {
  id: string;
  setLoading: (val: boolean) => void;
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [externalLogin] = useExternalLoginMutation();

  const from = location.state?.from?.pathname || '/';

  const handleSucccess = async (tokenResponse: TokenResponse) => {
    setLoading(true);
    const response: apiResponse = await externalLogin({
      provider: id,
      requestBody: JSON.stringify(tokenResponse),
    });
    if (response.data) {
      const { token } = response.data.result;

      const {
        FirstName,
        FranchiseId,
        LastName,
        email,
        Mobile,
        WhatsApp,
        nameid,
        exp,
        role,
      }: userModel = jwtDecode(token);
      storeAuthToken(token);
      dispatch(
        setLoggedInUser({
          FirstName,
          FranchiseId,
          LastName,
          email,
          Mobile,
          WhatsApp,
          nameid,
          exp,
          role,
        })
      );
      window.location.replace(from);
    } else if (response.error) {
      if (response.error?.status === HttpStatusCode.PreconditionRequired) {
        dispatch(
          setUser({
            Email: response.error?.data.result.email,
            PhoneNumber: response.error?.data.result.phoneNumber,
          })
        );
        toastNotify('At first login, password change need.');
        navigate(`/auth/resetpassword/${response.error?.data.result.token}`);
      } else if (response.error?.status === HttpStatusCode.Unauthorized) {
        rtkErrorRead(response.error);
      } else if (response.error?.status === HttpStatusCode.NotAcceptable) {
        rtkErrorRead(response.error);
      } else {
        rtkErrorRead(response.error);
      }

      setLoading(false);
    }
  };

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      handleSucccess(tokenResponse);
    },
    onError: () => {
      rtkErrorRead('Google-Login Failed');
    },
    flow: 'implicit', // or 'auth-code' if using code flow
  });

  return (
    <Link
      onClick={() => login()}
      to="#"
      className="inline-flex h-8 w-8 items-center justify-center rounded-full p-0 transition hover:scale-110"
      style={{
        background:
          'linear-gradient(135deg, rgba(239, 18, 98, 1) 0%, rgba(67, 97, 238, 1) 100%)',
      }}
    >
      <IconGoogle />
    </Link>
  );
}

export default GoogleLoginButton;
